// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"L_TheComp__F1Q0t"};